<template>

    <div class="overlay" @click.self="closeChildPopup">

        <div class="popup" :style="{ 'margin-bottom': bottom + 'px' }">

            <slot></slot>

        </div>

    </div>

</template>

<script>

    export default {

        name: 'popup',

        props: {

            bottom: {
                type: Number,
                default: 11
            }
        },

        methods: {

            closeChildPopup () {
                this.$emit('closePopup')
            }
        }

    }

</script>

<style scoped lang="scss">

    .overlay {
        z-index: 2;
        position: fixed;
        top: 0px;
        left: 0px;
        width: 100%;
        height: 100vh;
        background-color: rgba(0, 0, 0, 0);
        display: flex;
        align-items: flex-end;
        justify-content: center;

    }

    .popup {
        position: fixed;
        bottom: 12px;
        left: 8px;
        right: 8px;
        background-color: $midnight;
        min-height: 50px;
        box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.5);
        display: flex;
        color: $white;
        display: flex;
        justify-content: center;
        z-index: 2;
        @media screen and (min-width: $above-tablet-length)  {
            left: auto;
            max-width: 304px;
        }
    }

</style>
